import { ReactComponent as FacebookRound } from './icon.svg'

export default FacebookRound
